// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"39fed902","1640":"eb9f90cb","2522":"35996eec","4728":"83837f5f","4773":"35996eec","8063":"9eabb046","8192":"297e3740"}[chunkId] + ".chunk.css";
};